(function() {
    'use strict';

    angular.module('app').controller('jumbotronController', jumbotronController);

    jumbotronController.$inject = ['$scope'];

    function jumbotronController($scope) {
        /* jshint validthis:true */
        var vm = this;
        vm.visibleBecomeCustomerForm = false;
        vm.notEmptyBecomeCustomerBlock = false;

        vm.init = function (notEmptyBecomeCustomerBlock) {
            vm.notEmptyBecomeCustomerBlock = notEmptyBecomeCustomerBlock;
        };

        vm.resetBecomeCustomerForm = function () {
            $scope.$broadcast('resetUserForm');
        };

        vm.toggleBecomeCustomerFormVisibility = function () {
            if (vm.notEmptyBecomeCustomerBlock) {
                vm.visibleBecomeCustomerForm = !vm.visibleBecomeCustomerForm;
            }
        };
    }
})();